import React from "react";
import { connect, useSelector } from "react-redux";
import InputController from "../shared/Input/InputField/InputController";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { updatePasswordValidationSchema, setPasswordValidationSchema } from "../MyContactInfo/updateValidationSchema";
import { changePassword } from "../../redux/slices/updateUserSlice";
import Button from "../shared/Button/Button";
import Spinner from '../shared/Loaders/Spinner';
import {changePass as Styles} from "./changePass.tailwind";
import OverlayLoader from "../shared/Loaders/OverlayLoader/OverlayLoader";

const RequestToChangePassword = ( {setPassword}) => {
  const { user, userDetailsLoading } = useSelector((state) => state.user);
  const{ changingPassword } = useSelector((state) => state.updateUser);
  const { passwordPolicy } = useSelector((state) => state.passwordPolicy);

  //fetch user details to know whether the user has a password
  const profileData = user?.userDetails;

  //for form validation
  const validationSchema = profileData?.hasPassword ? updatePasswordValidationSchema(passwordPolicy) : setPasswordValidationSchema(passwordPolicy);

  //initialize react-hook-form
  const { control, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(validationSchema), 
  });

  // Function to update the password
  const updateNewPassword = async (formData) => {
    const data = {
      userPassword: formData.password,
      userConfirmPassword: formData.confirmPassword,
    };

    // Include the old password only if it's visible
    if (profileData?.hasPassword) {
      data.oldPassword = formData.currentPassword;  // Add currentPassword to the data if the field is shown
    }

    // Dispatch to update the password
    setPassword(data);
  };

  return (    
    <div className={Styles.spinnerContainer}>
      {changingPassword && <OverlayLoader />}
      {userDetailsLoading ? (
          <div className={Styles.spinner}>
            <Spinner />
          </div>
      ) : (
        <div className="w-full flex items-center justify-center h-screen">
          <div className={Styles.outerContainer}>
            {/* Header */}
            <div className={Styles.header}>
              {/* conditionally render the heading- change password or set password */}
              <span className={Styles.heading}>{profileData?.hasPassword ? "Change Password" : "Set Password"}</span>
              <p className={Styles.subHeading}>{profileData?.hasPassword ? "Your password hasn't been updated in a while. You are required to change it to maintain account security." : "Set a password to secure your account and protect your personal information."}</p>
            </div>

            {/* Info Section */}
            {/* <div className={Styles.info}>
              {/* <span className={Styles.infoHeading}>Password Change Required</span>
              <span className={Styles.infoText}>For security, you must change your password before continuing.</span> */}
              {/* <span>Your password hasn't been updated in a while. We recommend changing it for better security.</span> */}
            {/* </div>  */}

            {/* Form */}
            <form onSubmit={handleSubmit(updateNewPassword)} className={Styles.form}>
              <div className={Styles.inputFields}>
                {/* Current Password Field- if user already has a password */}
                {profileData?.hasPassword && (
                  <InputController
                    showLabel={true}
                    label="Current Password"
                    name="currentPassword"
                    type="password"
                    control={control} // Pass control object
                    error={!!errors.currentPassword} // Check for errors
                    helperText={errors.currentPassword?.message} // Display validation error
                  />
                )}

                {/* New Password Field */}
                <InputController
                  showLabel={true}
                  label="New Password"
                  name="password"
                  type="password"
                  control={control}
                  error={!!errors.password}
                  helperText={errors.password?.message}
                />

                {/* Confirm Password Field */}
                <InputController
                  showLabel={true}
                  label="Confirm Password"
                  name="confirmPassword"
                  type="password"
                  control={control}
                  error={!!errors.confirmPassword}
                  helperText={errors.confirmPassword?.message}
                />
              </div>

              {/* Submit Button */}
              <Button
                type="submit"
                variant="primary"
              >
                {profileData?.hasPassword 
                    ? (changingPassword ? "Updating..." : "Change Password") 
                    : (changingPassword ? "Saving..." : "Set Password")
                  }
              </Button>
            </form>
          </div>
        </div>
      )}  
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setPassword: (data) => dispatch(changePassword(data)),
});

export default connect(null, mapDispatchToProps)(RequestToChangePassword);
